/**
 * The company name the operator portal shows (header, Home, Settings). 0202: when the tenant
 * is linked to a platform operator that Paelode gave a display name ("DEVON ENERGY"), that
 * name; otherwise the tenant's own name, as before.
 */
import type { OperatorPortalMeResponse } from '@lodex-pro/shared/validation/operator-portal-me';

export function portalOrgName(
  me: Pick<OperatorPortalMeResponse, 'tenantName' | 'platformOperator'> | undefined,
): string {
  if (me === undefined) return '';
  const display = me.platformOperator?.displayName ?? null;
  return display !== null && display.trim() !== '' ? display : me.tenantName;
}
